import { EHeadingStyleVariant, Heading, Text, TextInput } from '@outdoorsyco/bonfire';
import React from 'react';
import { Control, Controller, FieldErrors } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';

import { EPersonalInfoFields, TPersonalInfoValues } from '../ProfileEdit';

interface ILegalNameProps {
  control: Control<TPersonalInfoValues>;
  errors: FieldErrors<TPersonalInfoValues>;
}

export const LegalName = ({ control, errors }: ILegalNameProps) => {
  const intl = useIntl();

  return (
    <div className="mb-2 md:mb-0">
      <Heading variant={EHeadingStyleVariant.H6} className="mb-1">
        <FormattedMessage defaultMessage="Legal name" id="OozR1Y" />
      </Heading>
      <Text className="mb-6 text-secondary-base">
        <FormattedMessage
          defaultMessage="Enter your full name as it appears on your driver's license or passport."
          id="E56cMi"
        />
      </Text>
      <div className="flex flex-col gap-3 md:flex-row md:gap-2">
        <Controller
          name={EPersonalInfoFields.FirstName}
          control={control}
          rules={{
            required: intl.formatMessage({
              defaultMessage: 'First name is required',
              id: 'FZI5xl',
            }),
            pattern: {
              value: /^[A-Za-z](?:[A-Za-z]|[ '-](?=[A-Za-z]))*[A-Za-z]$/,
              message: intl.formatMessage({
                defaultMessage:
                  'Please enter a valid first name (2+ characters, no special characters or numbers).',
                id: 'ck6IFm',
              }),
            },
          }}
          render={({ field: { value, onChange } }) => (
            <TextInput
              className="flex-1"
              controlled
              inputValue={String(value) || ''}
              onChange={onChange}
              ariaLabel={intl.formatMessage({
                defaultMessage: 'First name input field',
                id: '9UH6iu',
              })}
              label={intl.formatMessage({
                defaultMessage: 'First name',
                id: 'pONqz8',
              })}
              error={!!errors.firstName}
              helpText={errors.firstName?.message}
            />
          )}
        />
        <Controller
          name={EPersonalInfoFields.LastName}
          control={control}
          rules={{
            required: intl.formatMessage({
              defaultMessage: 'Last name is required',
              id: 'yos4hi',
            }),
            pattern: {
              value: /^[A-Za-z](?:[A-Za-z]|[ '-](?=[A-Za-z]))*[A-Za-z]$/,
              message: intl.formatMessage({
                defaultMessage:
                  'Please enter a valid last name (2+ characters, no special characters or numbers).',
                id: 'Q9TrFL',
              }),
            },
          }}
          render={({ field: { value, onChange } }) => (
            <TextInput
              className="flex-1"
              controlled
              inputValue={String(value) || ''}
              onChange={onChange}
              ariaLabel={intl.formatMessage({
                defaultMessage: 'Last name input field',
                id: 'xMnOSH',
              })}
              label={intl.formatMessage({
                defaultMessage: 'Last name',
                id: 'txUL0F',
              })}
              error={!!errors.lastName}
              helpText={errors.lastName?.message}
            />
          )}
        />
      </div>
    </div>
  );
};
